import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ClassContainer } from "../teacher/ClassEdit";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";
import {
  getDocs,
  collection,
  doc,
  where,
  query as firestoreQuery,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";
import ApexChartsComponent from "../../components/charts/ApexChartsComponent";
import ReactTable3 from "../../components/tables/ReactTable3";

function ChildrenEdit() {
  const [user] = useAuthState(auth);
  const { studentUid } = useParams();
  const [userData, setUserData] = useState({});
  const [homeworks, setHomeworks] = useState([]);
  const [activeTab, setActiveTab] = useState("istatistik");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = firestoreQuery(
          collection(db, "users"),
          where("uid", "==", studentUid)
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          const docData = snapshot.docs[0].data();
          setUserData(docData.userData || {});
          setHomeworks(docData.homeworks || []);
        }
      } catch (error) {
        console.error("Öğrenci verisi alınamadı:", error);
      }
    };

    fetchData();
  }, [studentUid]);

  const tamamlandi = homeworks.filter((item) => item.bittiMi === 1).length;
  const tamamlanmadi = homeworks.filter((item) => item.bittiMi === 0).length;

  const data = homeworks.map((item, index) => ({
    id: item.id,
    no: index + 1,
    className: item.className || "-",
    unit: item.unit || "-",
    kazanims: Array.isArray(item.kazanims)
      ? item.kazanims.join(", ")
      : item.kazanims || "-",
    startDate: item.startDate || "-",
    endDate: item.endDate || "-",
    durum: item.bittiMi === 1 ? "Tamamlandı" : "Tamamlanmadı",
    puan: item.puan || "-",
  }));

  return (
    <ClassContainer>
      <ProfileCard>
        <h2>{userData.displayName || "Öğrenci Adı"}</h2>
        <p>Takip ettiğiniz öğrencinin durumu aşağıda listelenmiştir.</p>
      </ProfileCard>

      <TabMenu>
        <TabButton
          active={activeTab === "istatistik"}
          onClick={() => setActiveTab("istatistik")}
        >
          📊 İstatistik
        </TabButton>
        <TabButton
          active={activeTab === "tablo"}
          onClick={() => setActiveTab("tablo")}
        >
          📋 Ödev Tablosu
        </TabButton>
      </TabMenu>

      <TabContent>
        {activeTab === "istatistik" && (
          <ApexChartsComponent
            tamamlandi={tamamlandi}
            tamamlanmadi={tamamlanmadi}
          />
        )}
        {activeTab === "tablo" && <ReactTable3 data={data} />}
      </TabContent>
    </ClassContainer>
  );
}

export const ProfileCard = styled.div`
  text-align: center;
  padding: 20px;
  background: var(--main-color);
  width: 100%;
  margin-bottom: 20px;
  color: #fff;
`;

export const TabMenu = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const TabButton = styled.button`
  flex: 1;
  padding: 10px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background: ${(props) =>
    props.active ? "var(--main-color)" : "var(--accent-color)"};
  color: ${(props) => (props.active ? "white" : "var(--main-color)")};
  font-weight: bold;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${(props) => (props.active ? "#4b2f66" : "var(--third-color)")};
  }
`;

export const TabContent = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
`;

export default ChildrenEdit;
